__turbopack_context__.v({
  "asset": "BYSviW_asset",
  "fileName": "BYSviW_fileName",
});
